import script from "./KanbanColumnWeekend.vue?vue&type=script&setup=true&lang=js"
export * from "./KanbanColumnWeekend.vue?vue&type=script&setup=true&lang=js"

import "./KanbanColumnWeekend.vue?vue&type=style&index=0&id=3d847e3b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d847e3b"]])

export default __exports__